import React from 'react';
import { Button } from 'primereact/button';

const TableRowAssignment = ({el, order, handleAssignment}) => {

    return (
        <tr>
            <th scope="row">{++order}</th>
            <td>{el.nombre} {el.apellido1} {el.apellido2}</td>
            <td>{el.fecha_registro}</td>
            <td>{el.institucion_educativa}</td>
            <td>{el.titulo}</td>
            <td>{el.correo_electronico}</td>
            <td>{el.telefono}</td>
            <td>
                <Button type="button" label="Asignación" icon="pi pi-share-alt" onClick={() => handleAssignment(el.solicitudid)} />
            </td>
        </tr>
    );  
}

export default TableRowAssignment;